import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react';
import { apiBaseUrl } from './api.config';
import { v4 as uuidv4 } from 'uuid';
import { getChannelInfoId } from 'utils/functions/getChannelInfoId';

let sessionId = uuidv4();

const channelInfoId = getChannelInfoId();

const baseQuery = fetchBaseQuery({
  baseUrl: apiBaseUrl,
  credentials: 'include',
  prepareHeaders(headers) {
    const callId = headers.get('X-Call-ID') || uuidv4();
    const xSessionId = headers.get('X-Session-ID');
    //we only do this if we call the login mutation to get a new session id
    //in case the login mutation returns a success response
    //but we fail later in the flow and we have to repeat the login
    //(if we do a successfull login twice with the same session id we will get a 401 error)
    if (xSessionId) {
      sessionId = xSessionId;
    }

    headers.set('Content-Type', 'application/json');
    headers.set('X-Call-ID', callId);
    headers.set('X-Session-ID', sessionId);
    headers.set('X-Channel-ID', channelInfoId);

    return headers;
  },
});

const baseQueryWithConfig: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);
  return result;
};

export const api = createApi({
  baseQuery: baseQueryWithConfig,
  endpoints: () => ({}),
});
